import React, { useCallback, useEffect, useRef } from 'react';

import { StyledMarkdownContainer } from '@mewa/ui';

import { getAssetUrl } from '../../../../libs/transform-asset-url';

export type MarkdownContentWithImageDescriptionProps = {
  html: string;
  id?: string;
};

export const MarkdownContentWithImage = ({
  html,
  id,
}: MarkdownContentWithImageDescriptionProps) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const hasInsertedImageDescriptions = useRef(false);

  const cleanUpContent = useCallback(() => {
    if (elementRef.current) {
      elementRef.current.querySelectorAll('img').forEach(replaceImageSrc);
      elementRef.current
        .querySelectorAll('a')
        .forEach(openExternalLinkInNewTab);
    }
  }, [elementRef]);

  useEffect(() => {
    if (!hasInsertedImageDescriptions.current) {
      cleanUpContent();
      hasInsertedImageDescriptions.current = true;
    }
  }, [cleanUpContent]);

  return <StyledMarkdownContainer ref={elementRef} html={html} id={id} />;
};

const replaceImageSrc = (imgElement: HTMLImageElement) => {
  const src = imgElement.getAttribute('src');

  if (src) {
    const newSrc = getAssetUrl(src, process.env['GATSBY_ASSETS_HOST']);
    imgElement.setAttribute('src', newSrc ?? src);
    imgElement.removeAttribute('style');
  }
};

const openExternalLinkInNewTab = (anchorElement: HTMLAnchorElement) => {
  if (anchorElement.getAttribute('href')?.startsWith('http')) {
    anchorElement.setAttribute('target', '_blank');
  }
};
